module.exports = __webpack_public_path__ + "img/an-evengroup-company_logo-morado.b388b4b9.svg";